import { DataFieldWithDataType } from '../../types';
import { ApiValueDataType } from '../types';
import { parseCustomSqlValue } from '../utils';
import { Employee, EmployeeProfileData } from './types';

export const employeeTypeDataMapper = (
  data: ApiValueDataType[][] | null
): Employee[] => {
  return (
    data?.map((employee) => {
      console.log2('employeeTypeDataMapper', employee);
      return {
        id: parseCustomSqlValue(employee[0] ?? null) as string,
        companyEmail: parseCustomSqlValue(employee[1] ?? null) as string,
        firstName: parseCustomSqlValue(employee[2] ?? null) as string,
        lastName: parseCustomSqlValue(employee[3] ?? null) as string,
        fullName: parseCustomSqlValue(employee[4] ?? null) as string,
        localFullName: parseCustomSqlValue(employee[5] ?? null) as string,
        localFirstName: parseCustomSqlValue(employee[6] ?? null) as string,
        localLastName: parseCustomSqlValue(employee[7] ?? null) as string,
        preferredName: parseCustomSqlValue(employee[8] ?? null) as string,
        localPreferredName: parseCustomSqlValue(employee[9] ?? null) as string,
        jobTitle: parseCustomSqlValue(employee[10] ?? null) as string,
      };
    }) ?? []
  );
};

export const employeeProfileTypeDataMapper = (
  data: ApiValueDataType[][] | null,
  fields: DataFieldWithDataType[],
  valueFormatter: (
    field: DataFieldWithDataType,
    value: string | undefined
  ) => string | null
): EmployeeProfileData[] => {
  return (
    data?.map((employee) => {
      return {
        fullName: valueFormatter(
          fields[0],
          parseCustomSqlValue(employee[0]) as string | undefined
        ),
        employeeId: valueFormatter(
          fields[1],
          parseCustomSqlValue(employee[1]) as string
        ),
        joiningAgeGroup: valueFormatter(
          fields[2],
          parseCustomSqlValue(employee[2]) as string | undefined
        ),
        locationLevel1: valueFormatter(
          fields[3],
          parseCustomSqlValue(employee[3]) as string | undefined
        ),
        locationLevel2: valueFormatter(
          fields[4],
          parseCustomSqlValue(employee[4]) as string | undefined
        ),
        locationLevel3: valueFormatter(
          fields[5],
          parseCustomSqlValue(employee[5]) as string | undefined
        ),
        organizationLevel1: valueFormatter(
          fields[6],
          parseCustomSqlValue(employee[6]) as string | undefined
        ),
        organizationLevel2: valueFormatter(
          fields[7],
          parseCustomSqlValue(employee[7]) as string | undefined
        ),
        jobTitle: valueFormatter(
          fields[8],
          parseCustomSqlValue(employee[8]) as string | undefined
        ),
        jobGradeLevel1: valueFormatter(
          fields[9],
          parseCustomSqlValue(employee[9]) as string | undefined
        ),
        jobGradeLevel2: valueFormatter(
          fields[10],
          parseCustomSqlValue(employee[10]) as string | undefined
        ),
        jobGradeLevel3: valueFormatter(
          fields[11],
          parseCustomSqlValue(employee[11]) as string | undefined
        ),
        startDate: valueFormatter(
          fields[12],
          parseCustomSqlValue(employee[12]) as string | undefined
        ),
        termDate: valueFormatter(
          fields[13],
          parseCustomSqlValue(employee[13]) as string | undefined
        ),
        baseSalary: valueFormatter(
          fields[14],
          parseCustomSqlValue(employee[14]) as string | undefined
        ),
        baseSalaryCurrency: valueFormatter(
          fields[15],
          parseCustomSqlValue(employee[15]) as string | undefined
        ),
        baseSalaryFrequency: valueFormatter(
          fields[16],
          parseCustomSqlValue(employee[16]) as string | undefined
        ),
        baseSalaryPerYear: valueFormatter(
          fields[17],
          parseCustomSqlValue(employee[17]) as string | undefined
        ),
        annualCashBonus1: valueFormatter(
          fields[18],
          parseCustomSqlValue(employee[18]) as string | undefined
        ),
        annualCashBonus1Currency: valueFormatter(
          fields[19],
          parseCustomSqlValue(employee[19]) as string | undefined
        ),
        icr: valueFormatter(
          fields[20],
          parseCustomSqlValue(employee[20]) as string | undefined
        ),
        performanceRating: valueFormatter(
          fields[21],
          parseCustomSqlValue(employee[21]) as string | undefined
        ),
      };
    }) ?? []
  );
};
